import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
const MENTION_SECTION_VARIANTS = {
    tab: true,
    file: true,
    space: true,
    shortcut: true,
    sources: true,
    'search-mode': true,
    skills: true,
    plugin: true,
    'slash-command': true,
    device: true,
    user: true,
};
function isMentionSectionVariant(variant) {
    return Object.hasOwn(MENTION_SECTION_VARIANTS, variant);
}
/**
 * Resolves the section copy shared by legacy AskInput and its Composer mention adapter.
 * @returns The localized category title, or the uppercase category for unknown values.
 */
export function getMentionSectionTitle({ $t, spacesCopyVariant, variant, }) {
    if (!isMentionSectionVariant(variant))
        return variant.toLocaleUpperCase();
    switch (variant) {
        case 'tab':
            return $t({
                defaultMessage: 'Tabs',
                id: '4ce1110606',
                description: 'Label in the Mentions Plugin form input section',
            });
        case 'file':
            return $t({
                defaultMessage: 'Files',
                id: '152db3a8b5',
                description: 'Label in the Mentions Plugin form input section',
            });
        case 'space':
            if (spacesCopyVariant === 'project') {
                return $t({
                    defaultMessage: 'Projects',
                    id: 'f540f2cc52',
                    description: 'Label in the Mentions Plugin form input section',
                });
            }
            return $t({
                defaultMessage: 'Spaces',
                id: 'dd1f3c2630',
                description: 'Label in the Mentions Plugin form input section',
            });
        case 'shortcut':
            return $t({
                defaultMessage: 'Shortcuts',
                id: 'b555f075ba',
                description: 'Label in the Mentions Plugin form input section',
            });
        case 'sources':
            return $t({
                defaultMessage: 'Connectors',
                id: 'e0716ef87d',
                description: 'Label in the Mentions Plugin form input section',
            });
        case 'search-mode':
            return $t({
                defaultMessage: 'Search mode',
                id: '8e261c33c3',
                description: 'Label in the Mentions Plugin form input section',
            });
        case 'skills':
            return $t({
                defaultMessage: 'Skills',
                id: '3d98771b17',
                description: 'Label in the Mentions Plugin form input section for skills',
            });
        case 'plugin':
            return $t({
                defaultMessage: 'Plugins',
                id: '2e727f4174',
                description: 'Label in the Mentions Plugin form input section for plugins',
            });
        case 'slash-command':
            return $t({
                defaultMessage: 'Commands',
                id: 'cabc9f36f0',
                description: 'Label in the Mentions Plugin form input section for slash commands',
            });
        case 'device':
            return $t({
                defaultMessage: 'Devices',
                id: '7a225bf4cd',
                description: 'Label in the Mentions Plugin form input section',
            });
        case 'user':
            return $t({
                defaultMessage: 'People',
                id: '978152c56e',
                description: 'Label in the Mentions Plugin form input section for users',
            });
        default:
            return assertUnreachableValue(variant);
    }
}
//# sourceMappingURL=mentionSectionTitle.js.map